import { Col, Image, Row, Skeleton, Space, Typography } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { DefaultModal } from "components/Shared/DefaultModal";
import { Uniforms } from "components/Uniforms/Uniforms";
import { ImageTypes } from "enums/imageTypes";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { useSportConfiguration } from "../../../../hooks/useSportConfiguration.ts";
import { EntityDetailsFieldValue } from "./EntityDetailsFieldValue";

type Props = {
  entity: any;
  isLoading: boolean;
};
export const EntityDetails = ({ isLoading, entity }: Props) => {
  const { formatMessage } = useIntl();
  const [openModal, setOpenModal] = useState(false);
  const { uiConfiguration } = useSportConfiguration();

  if (isLoading) {
    return <Skeleton paragraph={{ rows: 8 }} />;
  }

  return (
    <>
      <Typography.Title level={5}>{formatMessage({ id: "dashboardPage.entityDetails.title" })}</Typography.Title>

      <Row className="mb-25" gutter={10}>
        <Col span={4}>
          <Image
            preview={false}
            className="m-0"
            src={`${entity?.images?.filter((img) => img?.imageType === ImageTypes.Logo)?.[0]?.url}?size=400`}
            width="100%"
            alt={formatMessage({ id: "dashboardPage.entityDetails.logo" })}
            placeholder={true}
            fallback="data:image/png;base64,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"
          />
        </Col>
        <Col span={4}>
          <Space direction="vertical" size={15}>
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.nameFullLocal",
              })}
              value={entity?.nameFullLocal}
            />
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.codeLocal",
              })}
              value={entity?.codeLocal}
            />
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.gender",
              })}
              value={entity?.gender ? formatMessage({ id: `gender.${entity?.gender}` }) : undefined}
            />
          </Space>
        </Col>
        <Col span={4}>
          <Space direction="vertical" size={15}>
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.standard",
              })}
              value={entity?.standard ? formatMessage({ id: `standard.${entity?.standard}` }) : undefined}
            />
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.ageGroup",
              })}
              value={entity?.ageGroup ? formatMessage({ id: `ageGroup.${entity?.ageGroup}` }) : undefined}
            />
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.status",
              })}
              value={formatMessage({ id: `entityStatus.${entity?.status}` })}
            />
          </Space>
        </Col>
        <Col span={4}>
          <Space direction="vertical" size={15}>
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.entityGroup",
              })}
              value={entity.entityGroup?.nameFullLocal}
            />
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.defaultVenue",
              })}
              value={entity.defaultVenue?.nameLocal}
            />
            <EntityDetailsFieldValue
              title={formatMessage({
                id: "dashboardPage.entityDetails.discipline",
              })}
              value={entity?.discipline ? formatMessage({ id: `discipline.${entity?.discipline}` }) : undefined}
            />
          </Space>
        </Col>
        <Col span={1}>
          <Link to="edit">
            <DefaultButton
              disabled={!entity}
              size="large"
              type="text"
              icon={<i className="fa-solid fa-pen"></i>}
              title={formatMessage({ id: "button.editEntityDetails" })}
            />
          </Link>
          {uiConfiguration.uniforms.showEntityManageUniforms && (
            <>
              <DefaultButton
                size="large"
                disabled={!entity}
                type="text"
                onClick={() => setOpenModal(true)}
                icon={<i className="fa-solid fa-tshirt" />}
                title={formatMessage({ id: "button.manageUniforms" })}
              />
              {openModal && (
                <DefaultModal open={openModal} footer={null} onCancel={() => setOpenModal(false)}>
                  <Row className="mt-25">
                    <Col span={24}>
                      <Uniforms entityId={entity.entityId} />
                    </Col>
                  </Row>
                </DefaultModal>
              )}
            </>
          )}
        </Col>
      </Row>
    </>
  );
};
